import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {grey500} from 'material-ui/styles/colors';
import Radium from 'radium';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ContentCopy from 'material-ui/svg-icons/content/content-copy';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DeleteWidgetMutation from '../../mutations/DeleteWidgetMutation';
import CopyWidgetsDialog from '../../scenes/Report/components/ReportWrapper/components/ReportHeader/components/CopyWidgetsDialog';
import EditWidgetDialog from './components/EditWidgetDialog';



const styles = {
  wrapper: {
    position: 'relative',
  },
  actionsMenu: {
    position: 'absolute',
    top: '0',
    right: '0',
    icon: {
      color: grey500,
    },
  },
  deleteIcon: {
    position: 'absolute',
    top: '0',
    right: '48px',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: grey500,
    icon: {
      color: grey500,
    },
  },
};

@Radium
class WidgetMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteWidgetDialogOpen: false,
      editWidgetDialogOpen: false,
      copyWidgetsDialogOpen: false,
    };
  }

  showCopyWidgetsDialog = () => {
    this.setState({copyWidgetsDialogOpen: true});
  };

  hideCopyWidgetsDialog = () => {
    this.setState({copyWidgetsDialogOpen: false});
  };

  showEditWidgetDialog = () => {
    this.setState({editWidgetDialogOpen: true});
  };

  handleEditWidgetDialogClose = () => {
    this.setState({editWidgetDialogOpen: false});
  };

  showDeleteWidgetDialog = () => {
    this.setState({deleteWidgetDialogOpen: true});
  };

  handleEasyDelete = () => {
    DeleteWidgetMutation.commit({
      widgetId: this.props.widget.id,
    });
  };

  hideDeleteWidgetDialog = () => {
    this.setState({deleteWidgetDialogOpen: false});
  };

  deleteWidget = () => {
    this.setState({deleteWidgetDialogOpen: false});
    DeleteWidgetMutation.commit({
      widgetId: this.props.widget.id,
    });
  };

  render() {
    if (this.props.isAccountAdmin) {
      return (
        <div style={styles.wrapper}>

          {/* <div style={styles.deleteIcon}>
            <DeleteIcon 
              style={styles.deleteIcon.icon}
              onClick={this.handleEasyDelete}
            />
          </div> */}

          <IconMenu
            iconButtonElement={<IconButton><MenuIcon /></IconButton>}
            anchorOrigin={{horizontal: 'right', vertical: 'top'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}
            style={styles.actionsMenu}
            iconStyle={styles.actionsMenu.icon}
            >



            <MenuItem
              primaryText="Copy"
              leftIcon={<ContentCopy />}
              onTouchTap={this.showCopyWidgetsDialog}
            />
            <MenuItem
              primaryText="Edit"
              leftIcon={<EditIcon />}
              onTouchTap={this.showEditWidgetDialog}
            />
            <MenuItem
              primaryText="Delete"
              leftIcon={<DeleteIcon />}
              onTouchTap={this.showDeleteWidgetDialog}
            />
            {/* <MenuItem
              primaryText="Easy delete"
              leftIcon={<DeleteIcon />}
              onTouchTap={this.handleEasyDelete}
            /> */}
          </IconMenu>

          <CopyWidgetsDialog
            open={this.state.copyWidgetsDialogOpen}
            onClose={this.hideCopyWidgetsDialog}
            report={this.props.report}
            reports={this.props.reports}
          ></CopyWidgetsDialog>

          <EditWidgetDialog
            widget={this.props.widget}
            surveys={this.props.surveys}
            open={this.state.editWidgetDialogOpen}
            onClose={this.handleEditWidgetDialogClose}
          />

          <Dialog
            actions={[
              <FlatButton
                label="Cancel"
                onTouchTap={this.hideDeleteWidgetDialog}
              />,
              <RaisedButton
                label="Delete"
                primary={true}
                onTouchTap={this.deleteWidget}
              />,
            ]}
            modal={false}
            open={this.state.deleteWidgetDialogOpen}
            onRequestClose={this.hideDeleteWidgetDialog}
            >
            Are you sure you want to delete this widget?
          </Dialog>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default createFragmentContainer(
  WidgetMenu,
  graphql`
    fragment WidgetMenu_widget on Widget {
      id
      ...EditWidgetDialog_widget
    }
    fragment WidgetMenu_surveys on SurveyConnection {
      ...EditWidgetDialog_surveys
    }
    fragment WidgetMenu_reports on ReportConnection {
      ...CopyWidgetsDialog_reports
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/WidgetMenu.js